import type { RootState } from 'js/src/libs/RootState';

export const selectAllAnnouncements = (state: RootState) => state.announcements.list;

export const selectAnnouncementsIsLoading = (state: RootState) => state.announcements.isLoading;

export const selectAnnouncementsUnreadCount = (state: RootState) => state.announcements.unreadCount;
